import React, { useContext } from "react";
import cx from "classnames";

import ModalContext from "./ModalContext";
import { Button } from "@showitinc/showit-wc";

function DialogHeader(props) {
  const context = useContext(ModalContext);

  function _onCloseClick() {
    if (context.onHide) {
      context.onHide();
    }

    if (props.onHide) {
      props.onHide();
    }
  }

  const { children, closeButton, baseClassName, className, closeBtnBaseClassName, style } = props;

  return (
    <div className={cx(baseClassName, className)} style={style}>
      {closeButton && (
        <Button
          variant="icon"
          className={closeBtnBaseClassName}
          iconPrefix="close"
          onSIClick={_onCloseClick}
        />
      )}

      {children}
    </div>
  );
}

DialogHeader.defaultProps = {
  closeButton: false,
  baseClassName: "si-c-dialog__header",
  closeBtnBaseClassName: "si-c-dialog__header__close-btn",
};

export default DialogHeader;
